import { render } from "./seldon_1_7_optimal.vue?vue&type=template&id=11c90725"
import script from "./seldon_1_7_optimal.vue?vue&type=script&lang=js"
export * from "./seldon_1_7_optimal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/romanmatveev/Documents/Dev/html_docs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__